import React from "react";

export default function AnchorHeading(props) {
  function slugify(inputString) {
    let slug = inputString.toLowerCase();
    // For some reason, scroll position breaks
    // if we replace encoded spaces with '-'...
    // So we will leave them be

    // slug = slug.replace(/\s+/g, "-");

    // Remove special characters
    slug = slug.replace(/[^\w\s-]/g, "");

    return slug;
  }
  const heading = props.children ? props.children : props.heading;
  const headingId = props.children ? slugify(props.children) : slugify(props.heading);

  return (
    <div id={headingId} className="uk-visible-toggle">
      {heading}
      <a
        aria-hidden="true"
        tabIndex="-1"
        href={`#${encodeURIComponent(headingId)}`}
        data-uk-scroll="offset: 20"
        className="uk-link-reset"
        style={{ userSelect: "none" }}
      >
        <span className="uk-hidden-hover uk-text-muted uk-margin-small-left">#</span>
      </a>
    </div>
  );
}
